import { service } from '@ember/service';
import type { ValidatorMap } from 'ember-changeset/types';
import type IntlService from 'ember-intl/services/intl';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import PersonalNotesChangedJournalEvent from 'parog-web/models/personal-notes-changed-journal-event';

export default class PersonalNotesEditionFormComponent extends CrudJournalEventBaseComponent {
  static override forcDisplayName = 'Mes notes';
  static override fullComponentId = 'personal-notes/edition-form';
  static override journalEventClass = PersonalNotesChangedJournalEvent;

  @service declare intl: IntlService;

  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;

  override get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  override afterLoad(): void {
    const lastPersonalNoteJE = this.patient.personalNotesChangedJournalEvent;

    if (lastPersonalNoteJE) {
      this.changeset.set('note', lastPersonalNoteJE.note);
    }
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <div class='field'>
          Écrivez vos notes personnelles, pense-bête et ce que vous souhaitez.
          Ce que vous écrivez ici n'est pas partagé avec votre équipe de soins.
          <br /><br />
          <Form.TextArea @labelName='Notes' @propertyName='note' />
        </div>
      </:content>
    </Provider>
  </template>
}
